import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function tableBookingReducer(state = initialState.tableBooking, action) {
  switch (action.type) {
    case types.GET_TABLE_BOOKING_CONFIG_SUCCESS:
      return Object.assign({}, state, {
        config: action.config.configuration,
        times: {
          generalOpeningTimes: action.config.generalOpeningTimes,
          closedPeriods: action.config.generalOpeningTimes
        }
      });

    case types.SET_TABLE_BOOKING_SUCCESS: {
      let reservation = null;
      if (action.reservation) {
        const {reservationName, people, startDateTime, endDateTime, createdDateTime, email} = action.reservation;
        reservation = {
          reservationName,
          people,
          startDateTime,
          endDateTime,
          createdDateTime,
          email
        };
      }
      return Object.assign({}, state, {reservation});
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/tableBooking.reducer.js